import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { AddProjectForm } from '@/console/features/projects/components/project-drawer/add-project-form';
import {
  TAddProjectInputSchema,
  TAddProjectProps,
} from '@/console/features/projects/components/project-drawer/add-project.types';
import { addProjectInputSchema } from '@/console/features/projects/components/project-drawer/add-project.validation';
import { Form } from '@/shared/components/ui/form/form';
import { TSubmittedData } from '@/shared/components/ui/form/form.types';
import { useUpdateProjectMutation } from '@/shared/redux/api/assets/projects/projects-api';
import { UpdateProjectMutation } from '@/shared/types/types.generated';
import { showToastError } from '@/shared/utils/toast';

export const AddProject: React.FC<TAddProjectProps> = ({
  handlePopoverClose,
  groupId,
}) => {
  const { t } = useTranslation();
  const [updateProject] = useUpdateProjectMutation();

  const handleSubmit = async (data: TSubmittedData<TAddProjectInputSchema>) => {
    const projects = data.data.projects;

    try {
      const promises: Promise<UpdateProjectMutation>[] = [];
      projects?.forEach((project) => {
        promises.push(
          updateProject({
            projectId: project.projectId,
            project: { groupId, objectVersion: project.objectVersion + 1 },
          }).unwrap(),
        );
      });
      await Promise.all(promises);
      toast.success(
        t('projects:add_project_to_group_success', {
          count: projects?.length,
        }),
      );
      handlePopoverClose();
    } catch {
      showToastError(
        t('projects:add_project_to_group_error', {
          count: projects?.length,
        }),
      );
    }
  };

  return (
    <Form<TAddProjectInputSchema>
      onSubmit={(event) => handleSubmit(event)}
      schema={addProjectInputSchema}
    >
      {(formMethods) => (
        <AddProjectForm
          formMethods={formMethods}
          onClose={handlePopoverClose}
          groupId={groupId}
        />
      )}
    </Form>
  );
};
